export default {
  index: [
    {
      path: '/zkpromotermonthly',
      component: resolve => require(['./zkpromotermonthlyIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/zkpromoter_monthly/_router.js